/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetStorefrontCheckoutConfig200ResponseConfig } from './GetStorefrontCheckoutConfig200ResponseConfig';
import {
    GetStorefrontCheckoutConfig200ResponseConfigFromJSON,
    GetStorefrontCheckoutConfig200ResponseConfigFromJSONTyped,
    GetStorefrontCheckoutConfig200ResponseConfigToJSON,
    GetStorefrontCheckoutConfig200ResponseConfigToJSONTyped,
} from './GetStorefrontCheckoutConfig200ResponseConfig';
import type { CreateCatalogRequest } from './CreateCatalogRequest';
import {
    CreateCatalogRequestFromJSON,
    CreateCatalogRequestFromJSONTyped,
    CreateCatalogRequestToJSON,
    CreateCatalogRequestToJSONTyped,
} from './CreateCatalogRequest';

/**
 * 
 * @export
 * @interface GetStorefrontCheckoutConfig200Response
 */
export interface GetStorefrontCheckoutConfig200Response {
    /**
     * 
     * @type {Array<CreateCatalogRequest>}
     * @memberof GetStorefrontCheckoutConfig200Response
     */
    brands: Array<CreateCatalogRequest>;
    /**
     * 
     * @type {GetStorefrontCheckoutConfig200ResponseConfig}
     * @memberof GetStorefrontCheckoutConfig200Response
     */
    config: GetStorefrontCheckoutConfig200ResponseConfig;
}

/**
 * Check if a given object implements the GetStorefrontCheckoutConfig200Response interface.
 */
export function instanceOfGetStorefrontCheckoutConfig200Response(value: object): value is GetStorefrontCheckoutConfig200Response {
    if (!('brands' in value) || value['brands'] === undefined) return false;
    if (!('config' in value) || value['config'] === undefined) return false;
    return true;
}

export function GetStorefrontCheckoutConfig200ResponseFromJSON(json: any): GetStorefrontCheckoutConfig200Response {
    return GetStorefrontCheckoutConfig200ResponseFromJSONTyped(json, false);
}

export function GetStorefrontCheckoutConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontCheckoutConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'brands': ((json['brands'] as Array<any>).map(CreateCatalogRequestFromJSON)),
        'config': GetStorefrontCheckoutConfig200ResponseConfigFromJSON(json['config']),
    };
}

export function GetStorefrontCheckoutConfig200ResponseToJSON(json: any): GetStorefrontCheckoutConfig200Response {
    return GetStorefrontCheckoutConfig200ResponseToJSONTyped(json, false);
}

export function GetStorefrontCheckoutConfig200ResponseToJSONTyped(value?: GetStorefrontCheckoutConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brands': ((value['brands'] as Array<any>).map(CreateCatalogRequestToJSON)),
        'config': GetStorefrontCheckoutConfig200ResponseConfigToJSON(value['config']),
    };
}

